import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Filters out obvious outliers from odometer readings.
 * If the highest reading is more than 2x the second highest, it's likely an error.
 * @param readings Array of odometer readings sorted by reading DESC
 * @returns The highest valid reading value, or null if no valid readings
 */
export function filterOdometerOutliers(readings: Array<{ reading: number }>): number | null {
  if (!readings || readings.length === 0) return null;
  
  // If only one reading, return it
  if (readings.length === 1) return readings[0].reading;
  
  // If highest reading is more than 2x the second highest, it's likely an error
  if (readings[0].reading > readings[1].reading * 2) {
    return readings[1].reading;
  }
  
  return readings[0].reading;
}
